import {
  GRAPHITE_COLOR,
  ICE_COLOR,
  LG_COLOR,
  MAIN_BLUE_COLOR,
  WHITE_COLOR,
} from 'containers/App/constants';
import { Button, Modal } from 'react-bootstrap';
import styled from 'styled-components';

import { guideHtmlRenderTheme } from './guideHtmlRenderTheme';

export const GuideLauncherButton = styled(Button)`
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
  border: 1px solid rgb(165 1 53 / 22%);
  background: ${WHITE_COLOR};
  color: ${LG_COLOR};
  font-size: 0.88rem;
  font-weight: 600;
  white-space: nowrap;
  border-radius: 8px;
  padding: 8px 14px;
  box-shadow: 0 6px 16px rgb(15 23 42 / 6%);

  &:hover,
  &:focus,
  &:active {
    color: ${LG_COLOR} !important;
    border-color: rgb(165 1 53 / 34%) !important;
    background: #fff5f8 !important;
    box-shadow: 0 10px 22px rgb(15 23 42 / 9%);
  }

  .guide-launcher-dot {
    position: absolute;
    top: 4px;
    right: 6px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: ${LG_COLOR};
    box-shadow: 0 0 0 2px #fff;
  }

  @media (max-width: 768px) {
    padding: 8px 10px;

    .guide-launcher-label {
      display: none;
    }
  }

  @media (max-width: 1440px) {
    padding: 8px 10px;

    .guide-launcher-label {
      display: none;
    }
  }
`;

export const UserGuideModalStyles = styled(Modal)`
  /* ── Dialog shell ── */
  .user-guide-dialog {
    width: min(1200px, calc(100vw - 24px));
    max-width: none;
    margin: 16px auto;
  }

  .modal-content {
    display: flex;
    flex-direction: column;
    border: none;
    border-radius: 20px;
    overflow: hidden;
    height: min(780px, calc(100vh - 32px));
    box-shadow:
      0 0 0 1px rgb(15 23 42 / 6%),
      0 32px 80px rgb(15 23 42 / 22%),
      0 8px 24px rgb(15 23 42 / 10%);
    animation: guideModalIn 0.22s cubic-bezier(0.22, 1, 0.36, 1) both;
  }

  @keyframes guideModalIn {
    from { opacity: 0; transform: scale(0.97) translateY(8px); }
    to   { opacity: 1; transform: scale(1)   translateY(0);    }
  }

  .modal-header { display: none; }

  .modal-body {
    flex: 1;
    padding: 0;
    overflow: hidden;
  }

  /* ── Two-column layout ── */
  .guide-layout {
    display: grid;
    grid-template-columns: 280px 1fr;
    height: 100%;
    min-height: 0;
  }

  /* ────────────────────────────────────────
     SIDEBAR
  ──────────────────────────────────────── */
  .guide-sidebar {
    display: flex;
    flex-direction: column;
    min-height: 0;
    background: linear-gradient(160deg, #0f172a 0%, #1e1b4b 100%);
    color: #fff;
    overflow: hidden;
  }

  .guide-sidebar-header {
    padding: 28px 22px 20px;
    flex-shrink: 0;
  }

  .guide-brand {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    margin-bottom: 20px;
  }

  .guide-brand-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${LG_COLOR};
    box-shadow: 0 0 0 3px rgb(165 1 53 / 28%);
  }

  .guide-brand-label {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgb(255 255 255 / 50%);
  }

  .guide-sidebar-title {
    margin: 0 0 20px;
    font-size: 1.32rem;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: #fff;
    line-height: 1.2;
  }

  /* Tab pills inside sidebar */
  .guide-tab-pills {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  /* ── Divider between tabs and topics ── */
  .guide-topics-section {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    border-top: 1px solid rgb(255 255 255 / 10%);
    margin-top: 4px;
  }

  .guide-topics-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 22px 8px;
    flex-shrink: 0;
  }

  .guide-topics-section-label {
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgb(255 255 255 / 36%);
  }

  .guide-topics-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 18px;
    padding: 0 6px;
    border-radius: 999px;
    background: rgb(255 255 255 / 10%);
    color: rgb(255 255 255 / 50%);
    font-size: 0.68rem;
    font-weight: 800;
  }

  .guide-tab-pill {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 9px 14px;
    border: 1px solid rgb(255 255 255 / 8%);
    border-radius: 10px;
    background: rgb(255 255 255 / 4%);
    color: rgb(255 255 255 / 65%);
    font-size: 0.875rem;
    font-weight: 600;
    text-align: left;
    transition: all 0.18s ease;
    cursor: pointer;
  }

  .guide-tab-pill:hover {
    background: rgb(255 255 255 / 10%);
    color: #fff;
    border-color: rgb(255 255 255 / 16%);
  }

  .guide-tab-pill.active {
    background: ${LG_COLOR};
    border-color: transparent;
    color: #fff;
    box-shadow: 0 4px 14px rgb(165 1 53 / 40%);
  }

  .guide-new-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #fbbf24;
    box-shadow: 0 0 6px #fbbf24;
    margin-left: auto;
    flex-shrink: 0;
  }

  /* Topic list */
  .guide-topic-list {
    flex: 1;
    overflow-y: auto;
    padding: 0 12px 20px;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .guide-topic-list::-webkit-scrollbar { width: 4px; }
  .guide-topic-list::-webkit-scrollbar-track { background: transparent; }
  .guide-topic-list::-webkit-scrollbar-thumb {
    background: rgb(255 255 255 / 14%);
    border-radius: 999px;
  }

  .guide-topic-row {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 12px;
    border: none;
    border-radius: 10px;
    background: transparent;
    color: rgb(255 255 255 / 58%);
    font-size: 0.875rem;
    font-weight: 500;
    text-align: left;
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .guide-topic-row:hover {
    background: rgb(255 255 255 / 7%);
    color: rgb(255 255 255 / 90%);
  }

  .guide-topic-row.active {
    background: rgb(255 255 255 / 12%);
    color: #fff;
    font-weight: 700;
  }

  .guide-topic-num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 6px;
    background: rgb(255 255 255 / 8%);
    color: rgb(255 255 255 / 50%);
    font-size: 0.7rem;
    font-weight: 800;
    flex-shrink: 0;
    transition: all 0.15s ease;
  }

  .guide-topic-row.active .guide-topic-num {
    background: ${LG_COLOR};
    color: #fff;
  }

  .guide-topic-label { flex: 1; min-width: 0; line-height: 1.4; }

  .guide-topic-empty {
    margin: 12px;
    color: rgb(255 255 255 / 36%);
    font-size: 0.84rem;
  }

  /* ────────────────────────────────────────
     CONTENT PANE
  ──────────────────────────────────────── */
  .guide-content-pane {
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    background: #ffffff;
  }

  .guide-content-header-bar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 24px 28px 18px;
    border-bottom: 1px solid #f1f3f5;
    flex-shrink: 0;
  }

  .guide-content-header-meta { min-width: 0; }

  .guide-content-eyebrow {
    display: block;
    margin-bottom: 4px;
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${LG_COLOR};
    opacity: 0.8;
  }

  .guide-content-heading {
    margin: 0;
    font-size: 1.35rem;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.02em;
    line-height: 1.3;
  }

  .guide-close-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    background: #f9fafb;
    color: #6b7280;
    font-size: 1.3rem;
    line-height: 1;
    cursor: pointer;
    flex-shrink: 0;
    transition: all 0.15s ease;
    margin-top: 2px;
  }

  .guide-close-btn:hover {
    background: #fee2e2;
    border-color: #fca5a5;
    color: #dc2626;
  }

  .guide-content-scroll {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding: 28px;
  }

  .guide-content-scroll::-webkit-scrollbar { width: 6px; height: 6px; }
  .guide-content-scroll::-webkit-scrollbar-track { background: transparent; }
  .guide-content-scroll::-webkit-scrollbar-thumb {
    background: rgb(15 23 42 / 12%);
    border-radius: 999px;
  }

  ${guideHtmlRenderTheme}

  /* ── Content title row (from UserGuideContent) ── */
  .guide-content-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
  }

  /* ── Empty / loading states ── */
  .guide-empty-state {
    display: grid;
    place-items: center;
    height: 100%;
    padding: 32px;
    background: #fff;
  }

  .guide-empty-card {
    max-width: 400px;
    text-align: center;
    padding: 36px 28px;
  }

  .guide-empty-card h4 {
    margin: 0 0 8px;
    color: #0f172a;
    font-size: 1.1rem;
    font-weight: 700;
  }

  .guide-empty-card p {
    margin: 0;
    color: #6b7280;
    line-height: 1.65;
  }

  .guide-empty-card-compact {
    max-width: none;
    text-align: left;
    padding: 18px;
  }

  /* spinner */
  .guide-spinner-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    color: #6b7280;
  }

  .guide-spinner-ring {
    width: 36px;
    height: 36px;
    border: 3px solid #e5e7eb;
    border-top-color: ${LG_COLOR};
    border-radius: 50%;
    animation: guideSpin 0.7s linear infinite;
  }

  @keyframes guideSpin {
    to { transform: rotate(360deg); }
  }

  .guide-error-state { padding: 24px; background: #fff; }

  /* badges */
  .guide-recent-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 7px;
    border-radius: 999px;
    background: #fef3c7;
    color: #92400e;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  /* content body typography */
  .guide-step-stack { display: grid; gap: 16px; }

  .guide-step-card {
    display: flex;
    flex-direction: column;
    gap: 14px;
    border: 1px solid #f1f3f5;
    border-radius: 12px;
    background: #fafafa;
    padding: 20px;
  }

  .guide-step-header { display: grid; gap: 6px; }

  .guide-step-index {
    display: inline-flex;
    width: fit-content;
    align-items: center;
    border-radius: 6px;
    background: rgb(165 1 53 / 8%);
    color: ${LG_COLOR};
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    padding: 3px 10px;
    text-transform: uppercase;
  }

  .guide-step-header h4 {
    margin: 0;
    color: #0f172a;
    font-size: 1.05rem;
    font-weight: 700;
  }

  .guide-step-description {
    margin: 0;
    color: #475467;
    font-size: 0.94rem;
    line-height: 1.75;
    white-space: pre-line;
  }

  .guide-step-image-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  .guide-step-image-card { margin: 0; display: grid; gap: 10px; }

  .guide-step-image-frame {
    overflow: hidden;
    border-radius: 10px;
    background: #f4f5f7;
    border: 1px solid #eceef1;
  }

  .guide-step-image-frame img { display: block; width: 100%; height: auto; }

  .guide-step-image-card figcaption {
    margin: 0;
    color: #667085;
    font-size: 0.82rem;
    line-height: 1.6;
  }

  /* ── Responsive ── */
  @media (max-width: 860px) {
    .user-guide-dialog {
      width: calc(100vw - 12px);
      margin: 6px auto;
    }

    .modal-content {
      height: calc(100vh - 12px);
      border-radius: 14px;
    }

    .guide-layout {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr;
    }

    .guide-sidebar {
      border-right: none;
      border-bottom: 1px solid rgb(255 255 255 / 8%);
    }

    .guide-sidebar-header { padding: 18px 16px 14px; }

    .guide-tab-pills { flex-direction: row; flex-wrap: wrap; }
    .guide-tab-pill  { flex: 1; justify-content: center; }

    .guide-topic-list {
      flex-direction: row;
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      padding: 0 12px 12px;
    }

    .guide-topic-row { white-space: nowrap; }

    .guide-step-image-grid { grid-template-columns: 1fr; }
  }
`;

export const GuideHelpModalStyles = styled(Modal)`
  .modal-dialog {
    width: min(960px, calc(100vw - 32px));
    max-width: none;
  }

  .modal-content {
    border: 0;
    border-radius: 8px;
    box-shadow: 0 18px 48px rgba(65, 70, 80, 0.18);
    overflow: hidden;
  }

  .modal-header {
    background: #f3f5f8;
    border-bottom: 1px solid #d9dde3;
  }

  .modal-title {
    color: ${GRAPHITE_COLOR};
    font-size: 1.05rem;
    font-weight: 700;
  }

  .modal-body {
    max-height: min(72vh, 760px);
    overflow: auto;
    padding: 20px;
  }

  .guide-authoring-help {
    border: 1px solid #dde2e8;
    border-radius: 8px;
    background: #fff;
    padding: 18px;
  }

  .guide-authoring-help-header {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  .guide-authoring-help-copy {
    min-width: 0;
    flex: 1;
  }

  .guide-authoring-help-kicker {
    color: ${LG_COLOR};
    display: inline-flex;
    font-size: 0.76rem;
    font-weight: 700;
    margin-bottom: 8px;
    text-transform: uppercase;
  }

  .guide-authoring-help h3 {
    color: ${GRAPHITE_COLOR};
    font-size: 1rem;
    font-weight: 700;
    margin: 0 0 8px;
  }

  .guide-authoring-help p {
    color: #66707d;
    margin: 0;
  }

  .guide-authoring-help-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .guide-authoring-help-actions .btn {
    align-items: center;
    border-radius: 8px;
    display: inline-flex;
    gap: 8px;
    font-weight: 700;
  }

  .guide-authoring-help-actions .btn-secondary {
    background: ${LG_COLOR};
    border-color: ${LG_COLOR};
  }

  .guide-authoring-group-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    margin-top: 16px;
  }

  .guide-authoring-group-card {
    background: #f8f9fb;
    border: 1px solid #e3e7ec;
    border-radius: 8px;
    padding: 14px;
  }

  .guide-authoring-group-card h4 {
    align-items: center;
    color: ${GRAPHITE_COLOR};
    display: flex;
    gap: 8px;
    font-size: 0.92rem;
    font-weight: 700;
    margin: 0 0 12px;
  }

  .guide-authoring-token-list {
    display: grid;
    gap: 10px;
  }

  .guide-authoring-token {
    background: #fff;
    border: 1px solid #edf1f6;
    border-radius: 8px;
    display: grid;
    gap: 4px;
    padding: 10px 12px;
  }

  .guide-authoring-token code {
    color: ${GRAPHITE_COLOR};
    font-size: 0.8rem;
    font-weight: 700;
  }

  .guide-authoring-token span {
    color: #66707d;
    font-size: 0.82rem;
    line-height: 1.5;
  }

  .guide-authoring-status {
    color: #475467;
    font-size: 0.86rem;
    font-weight: 600;
    margin-top: 14px;
  }

  @media (max-width: 768px) {
    .guide-authoring-group-grid {
      grid-template-columns: 1fr;
    }
  }
`;

export const GuideManagementPageStyles = styled.div`
  min-height: 100%;
  padding: 24px;
  background: ${ICE_COLOR};

  ${guideHtmlRenderTheme}

  .guide-admin-shell {
    display: grid;
    gap: 18px;
    margin: 0 auto;
    max-width: 1400px;
  }

  .guide-management-hero {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    border: 1px solid #e4e7ec;
    border-radius: 8px;
    background:
      linear-gradient(90deg, rgb(165 1 53 / 9%) 0%, transparent 42%), #fff;
    padding: 18px 20px;
    box-shadow: 0 10px 22px rgb(15 23 42 / 4%);
  }

  .guide-management-title-block {
    min-width: 0;
  }

  .guide-management-kicker {
    display: inline-flex;
    margin-bottom: 6px;
    color: ${LG_COLOR};
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .guide-management-hero h1 {
    margin: 0;
    color: #111827;
    font-size: 1.45rem;
    font-weight: 700;
  }

  .guide-management-hero p {
    margin: 6px 0 0;
    color: #6b7280;
    max-width: 760px;
  }

  .guide-management-hero-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .guide-status-pill,
  .guide-primary-save {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 38px;
    border-radius: 8px;
    font-weight: 700;
  }

  .guide-status-pill {
    border: 1px solid #e5e7eb;
    background: #fff;
    color: #475467;
    padding: 0 12px;
    font-size: 0.84rem;
  }

  .guide-primary-save {
    border: 1px solid ${LG_COLOR};
    background: ${LG_COLOR};
    color: #fff;
    padding: 0 16px;
  }

  .guide-primary-save:disabled {
    cursor: not-allowed;
    border-color: #d0d5dd;
    background: #e5e7eb;
    color: #98a2b3;
  }

  .guide-management-stat-row {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .guide-stat-tile {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #e4e7ec;
    border-radius: 8px;
    background: #fff;
    padding: 12px 14px;
  }

  .guide-stat-tile svg {
    color: ${LG_COLOR};
  }

  .guide-stat-tile span {
    color: #111827;
    font-size: 1.1rem;
    font-weight: 800;
  }

  .guide-stat-tile strong {
    color: #667085;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .guide-management-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .guide-management-tab {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #fff;
    color: #4b5563;
    font-weight: 600;
  }

  .guide-management-tab.active {
    border-color: rgb(165 1 53 / 24%);
    background: #fff5f8;
    color: ${LG_COLOR};
    box-shadow: inset 0 -2px 0 ${LG_COLOR};
  }

  .guide-management-workspace {
    display: grid;
    grid-template-columns: minmax(260px, 300px) minmax(0, 1fr) minmax(
        360px,
        420px
      );
    gap: 14px;
    align-items: start;
  }

  .guide-panel {
    border: 1px solid #eceef1;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 10px 22px rgb(15 23 42 / 4%);
    overflow: hidden;
  }

  .guide-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 18px;
    border-bottom: 1px solid #f0f1f3;
  }

  .guide-editor-toolbar {
    position: sticky;
    top: 72px;
    z-index: 2;
    background: rgb(255 255 255 / 96%);
    backdrop-filter: blur(8px);
  }

  .guide-toolbar-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .guide-toolbar-actions .btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 8px;
    font-weight: 700;
  }

  .guide-state-badge {
    border-radius: 6px;
  }

  .guide-panel-header h2,
  .guide-panel-header h3 {
    margin: 0;
    color: #111827;
    font-size: 1rem;
    font-weight: 700;
  }

  .guide-panel-header p {
    margin: 4px 0 0;
    color: #6b7280;
    font-size: 0.84rem;
  }

  .guide-sidebar-panel,
  .guide-preview-panel {
    position: sticky;
    top: 72px;
  }

  .guide-editor-scroll {
    display: grid;
    gap: 14px;
    max-height: calc(100vh - 178px);
    overflow-y: auto;
    padding: 18px;
  }

  .guide-topics-list {
    display: grid;
    gap: 10px;
    max-height: calc(100vh - 178px);
    overflow-y: auto;
    padding: 16px;
  }

  .guide-topic-editor-item {
    display: grid;
    gap: 8px;
    padding: 10px;
    border: 1px solid #eceef1;
    border-radius: 8px;
    background: #fff;
  }

  .guide-topic-editor-item.active {
    border-color: rgb(165 1 53 / 24%);
    background: #fff8fa;
  }

  .guide-topic-editor-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .guide-topic-editor-actions .btn,
  .guide-step-editor-actions .btn {
    display: inline-flex;
    width: 32px;
    height: 30px;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    padding: 0;
  }

  .guide-topic-meta {
    color: #9ca3af;
    font-size: 0.74rem;
    font-weight: 600;
  }

  .guide-topic-meta-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 12px;
  }

  .guide-topic-editor-actions .btn,
  .guide-media-actions .btn,
  .guide-step-editor-actions .btn {
    font-size: 0.78rem;
  }

  .guide-form-grid {
    display: grid;
    gap: 14px;
  }

  .guide-settings-drawer {
    border: 1px solid #e4e7ec;
    border-radius: 8px;
    background: #fff;
  }

  .guide-settings-drawer summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
    list-style: none;
    padding: 14px 16px;
  }

  .guide-settings-drawer summary::-webkit-details-marker {
    display: none;
  }

  .guide-settings-drawer summary span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #111827;
    font-weight: 800;
  }

  .guide-settings-drawer summary small {
    color: #98a2b3;
    font-size: 0.74rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .guide-settings-body {
    display: grid;
    gap: 14px;
    border-top: 1px solid #f0f1f3;
    padding: 16px;
  }

  .guide-form-grid.two-column {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .guide-section-card {
    display: grid;
    gap: 14px;
    padding: 18px;
    border: 1px solid #eceef1;
    border-radius: 8px;
    background: #fcfcfd;
  }

  .guide-section-card h3 {
    margin: 0;
    color: #111827;
    font-size: 1rem;
    font-weight: 700;
  }

  .guide-inline-help {
    margin: -6px 0 0;
    color: #6b7280;
    font-size: 0.82rem;
    line-height: 1.55;
  }

  .guide-section-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .guide-media-list {
    display: grid;
    gap: 12px;
  }

  .guide-steps-editor-list,
  .guide-step-image-editor-list {
    display: grid;
    gap: 12px;
  }

  .guide-step-add-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .guide-step-add-actions .btn,
  .guide-section-header-row .btn,
  .guide-media-actions .btn,
  .guide-panel-header .btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 8px;
    font-weight: 700;
  }

  .guide-step-editor-card {
    display: grid;
    gap: 16px;
    padding: 18px;
    border: 1px solid #eceef1;
    border-radius: 8px;
    background: #fff;
  }

  .guide-step-editor-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .guide-step-editor-title {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .guide-step-editor-title strong {
    color: #111827;
    font-size: 0.95rem;
    font-weight: 700;
  }

  .guide-step-editor-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
  }

  .guide-step-images-section {
    display: grid;
    gap: 14px;
    padding-top: 2px;
  }

  .guide-media-item {
    display: grid;
    gap: 12px;
    padding: 14px;
    border: 1px solid #eceef1;
    border-radius: 8px;
    background: #fff;
  }

  .guide-media-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .guide-readonly-metric {
    display: flex;
    min-height: 38px;
    align-items: center;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: #f9fafb;
    padding: 0 12px;
    color: #475467;
    font-size: 0.9rem;
    font-weight: 600;
  }

  .guide-preview-shell {
    border: 1px solid #eceef1;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
  }

  .guide-preview-shell .guide-content-scroll {
    max-height: calc(100vh - 178px);
  }

  .guide-validation-card {
    display: grid;
    gap: 8px;
  }

  .guide-validation-card ul {
    margin: 0;
    padding-left: 18px;
  }

  @media (max-width: 1100px) {
    .guide-management-workspace {
      grid-template-columns: 1fr;
    }

    .guide-sidebar-panel,
    .guide-preview-panel,
    .guide-editor-toolbar {
      position: static;
    }

    .guide-editor-scroll {
      max-height: none;
    }

    .guide-topics-list,
    .guide-preview-shell .guide-content-scroll {
      max-height: none;
    }
  }

  @media (max-width: 768px) {
    padding: 14px;

    .guide-management-status-block,
    .guide-toolbar-actions,
    .guide-section-header-row,
    .guide-step-editor-header {
      width: 100%;
      flex-wrap: wrap;
    }

    .guide-form-grid.two-column {
      grid-template-columns: 1fr;
    }
  }

  /* ===== Admin Management Page Styles ===== */

  .guide-admin-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 24px 28px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgb(0 0 0 / 6%);
  }

  .guide-admin-header h1 {
    margin: 0;
    color: #111827;
    font-size: 1.75rem;
    font-weight: 800;
    letter-spacing: -0.02em;
  }

  .guide-admin-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .guide-admin-actions .btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 40px;
    padding: 8px 16px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 0.94rem;
    transition: all 0.2s ease;
    border: 1px solid transparent;
  }

  .guide-admin-actions .btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .guide-admin-actions .btn.btn-light {
    border-color: #d1d5db;
    color: #374151;
  }

  .guide-admin-actions .btn.btn-light:not(:disabled):hover {
    background: #f3f4f6;
    border-color: #9ca3af;
  }

  .guide-admin-actions .btn.btn-secondary {
    background: ${LG_COLOR};
    border-color: ${LG_COLOR};
    color: white;
  }

  .guide-admin-actions .btn.btn-secondary:not(:disabled):hover {
    background: ${LG_COLOR};
    border-color: ${LG_COLOR};
    filter: brightness(0.9);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgb(165 1 53 / 24%);
  }

  /* Settings Section */
  .guide-settings-card {
    padding: 24px 28px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgb(0 0 0 / 6%);
  }

  .guide-settings-card h2 {
    margin: 0 0 20px;
    color: #111827;
    font-size: 1.25rem;
    font-weight: 700;
  }

  .guide-settings-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 18px;
  }

  .guide-settings-grid .form-group {
    margin: 0;
  }

  .guide-settings-grid .form-label {
    display: block;
    margin-bottom: 8px;
    color: #374151;
    font-weight: 600;
    font-size: 0.94rem;
    letter-spacing: 0.01em;
  }

  .guide-settings-grid .form-control {
    height: 40px;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background: white;
    color: #111827;
    font-size: 0.94rem;
    transition: all 0.2s ease;
  }

  .guide-settings-grid .form-control:focus {
    border-color: ${LG_COLOR};
    box-shadow: 0 0 0 3px rgb(165 1 53 / 12%);
    outline: none;
  }

  /* Tabs Navigation */
  .guide-admin-tabs {
    display: flex;
    gap: 8px;
    padding: 12px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .guide-admin-tabs button {
    display: inline-flex;
    align-items: center;
    padding: 10px 16px;
    border: 2px solid transparent;
    border-bottom: none;
    border-radius: 8px 8px 0 0;
    background: transparent;
    color: #6b7280;
    font-size: 0.94rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
  }

  .guide-admin-tabs button:hover {
    background: #f3f4f6;
    color: #374151;
  }

  .guide-admin-tabs button.active {
    background: white;
    color: ${LG_COLOR};
    border-bottom: 3px solid ${LG_COLOR};
    padding-bottom: 7px;
  }

  /* Main Workspace */
  .guide-admin-workspace {
    display: grid;
    grid-template-columns: 300px 1fr 360px;
    gap: 16px;
    align-items: start;
  }

  /* Topics Panel */
  .guide-topics-card {
    padding: 0;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgb(0 0 0 / 6%);
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 340px);
  }

  .guide-topics-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 18px;
    border-bottom: 1px solid #f3f4f6;
  }

  .guide-topics-card-header h2 {
    margin: 0;
    color: #111827;
    font-size: 1.06rem;
    font-weight: 700;
  }

  .guide-topics-card-header .btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 32px;
    padding: 6px 12px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #d1d5db;
    color: #374151;
    font-weight: 600;
    font-size: 0.88rem;
    transition: all 0.2s ease;
  }

  .guide-topics-card-header .btn:hover {
    background: ${LG_COLOR};
    border-color: ${LG_COLOR};
    color: white;
  }

  .guide-admin-topic-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: auto;
    padding: 12px;
    flex: 1;
  }

  .guide-admin-topic-list button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    padding: 12px 14px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #fff;
    color: #374151;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 500;
    font-size: 0.94rem;
  }

  .guide-admin-topic-list button:hover {
    background: #f9f9fc;
    border-color: #d1d5db;
    color: #111827;
  }

  .guide-admin-topic-list button.active {
    background: linear-gradient(135deg, #fff5f8 0%, #fff8fa 100%);
    border-color: ${LG_COLOR};
    color: ${LG_COLOR};
    box-shadow: inset 2px 0 0 ${LG_COLOR}, 0 2px 6px rgb(165 1 53 / 10%);
    font-weight: 600;
  }

  .guide-admin-topic-actions {
    display: flex;
    gap: 6px;
    pointer-events: all;
  }

  .guide-admin-topic-actions svg {
    width: 18px;
    height: 18px;
    cursor: pointer;
    transition: all 0.2s ease;
    opacity: 0.6;
  }

  .guide-admin-topic-actions svg:hover {
    opacity: 1;
  }

  .guide-admin-topic-actions svg.disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  .guide-admin-topic-actions svg.danger {
    color: #dc2626;
  }

  /* Editor Section */
  .guide-editor-card {
    padding: 20px;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgb(0 0 0 / 6%);
  }

  .guide-editor-card h2 {
    margin: 0 0 18px;
    color: #111827;
    font-size: 1.06rem;
    font-weight: 700;
  }

  .guide-editor-card .form-group {
    margin-bottom: 16px;
  }

  .guide-authoring-help {
    margin: 0 0 18px;
    padding: 16px 18px;
    border: 1px solid #e5eaf2;
    border-radius: 12px;
    background: linear-gradient(180deg, #fcfdff 0%, #f7f9fc 100%);
  }

  .guide-authoring-help-header {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  .guide-authoring-help-copy {
    min-width: 0;
    flex: 1;
  }

  .guide-authoring-help-kicker {
    display: inline-flex;
    margin-bottom: 8px;
    color: ${LG_COLOR};
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .guide-authoring-help h3 {
    margin: 0 0 8px;
    color: #111827;
    font-size: 1rem;
    font-weight: 700;
  }

  .guide-authoring-help p {
    margin: 0;
    color: #667085;
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .guide-authoring-help-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .guide-authoring-help-actions .btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 38px;
    border-radius: 8px;
    font-weight: 700;
    white-space: nowrap;
  }

  .guide-authoring-status {
    margin: 14px 0 0;
    color: #475467;
    font-size: 0.85rem;
    font-weight: 600;
  }

  .guide-authoring-group-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    margin-top: 16px;
  }

  .guide-authoring-group-card {
    padding: 14px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    background: #ffffff;
    box-shadow: 0 1px 2px rgb(15 23 42 / 4%);
  }

  .guide-authoring-group-card h4 {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 12px;
    color: #111827;
    font-size: 0.92rem;
    font-weight: 700;
  }

  .guide-authoring-group-card h4 svg {
    color: ${LG_COLOR};
  }

  .guide-authoring-token-list {
    display: grid;
    gap: 10px;
  }

  .guide-authoring-token {
    display: grid;
    gap: 4px;
    padding: 10px 12px;
    border: 1px solid #edf1f6;
    border-radius: 8px;
    background: #f9fafb;
  }

  .guide-authoring-token code {
    color: #0f172a;
    font-size: 0.8rem;
    font-weight: 700;
  }

  .guide-authoring-token span {
    color: #667085;
    font-size: 0.82rem;
    line-height: 1.5;
  }

  .guide-editor-card .form-label {
    display: block;
    margin-bottom: 8px;
    color: #374151;
    font-weight: 600;
    font-size: 0.94rem;
  }

  .guide-editor-card .form-control {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 0.94rem;
    transition: all 0.2s ease;
  }

  .guide-editor-card .form-control:focus {
    border-color: ${LG_COLOR};
    box-shadow: 0 0 0 3px rgb(165 1 53 / 12%);
    outline: none;
  }

  .guide-html-textarea {
    min-height: 200px !important;
    font-family: 'Monaco', 'Courier New', monospace;
    font-size: 0.88rem;
    line-height: 1.6;
    letter-spacing: 0.01em;
  }

  .guide-admin-live-preview {
    padding: 16px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    margin: 12px 0;
    line-height: 1.6;
    color: #374151;
    font-size: 0.94rem;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .guide-admin-live-preview > * {
    max-width: none;
  }

  .guide-admin-live-preview table {
    border-collapse: collapse;
    max-width: none;
  }

  .guide-admin-live-preview img,
  .guide-admin-live-preview video {
    max-width: 100%;
    height: auto;
  }

  /* Media Library Section */
  .guide-media-card {
    padding: 20px;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgb(0 0 0 / 6%);
  }

  .guide-media-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
  }

  .guide-media-header > div {
    flex: 1;
  }

  .guide-media-header h2 {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 0 0 8px;
    color: #111827;
    font-size: 1.1rem;
    font-weight: 700;
  }

  .guide-media-header h2 svg {
    width: 24px;
    height: 24px;
    color: ${LG_COLOR};
  }

  .guide-media-header p {
    margin: 0;
    color: #6b7280;
    font-size: 0.94rem;
    line-height: 1.5;
  }

  .guide-media-header .btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 40px;
    padding: 8px 16px;
    border-radius: 8px;
    background: ${LG_COLOR};
    border: 1px solid ${LG_COLOR};
    color: white;
    font-weight: 600;
    font-size: 0.94rem;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .guide-media-header .btn:hover {
    background: ${LG_COLOR};
    filter: brightness(0.9);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgb(165 1 53 / 24%);
  }

  .guide-media-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 14px;
  }

  .guide-media-item {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #f9fafb;
    transition: all 0.2s ease;
  }

  .guide-media-item:hover {
    border-color: ${LG_COLOR};
    background: #fff5f8;
    box-shadow: 0 4px 12px rgb(165 1 53 / 12%);
  }

  .guide-media-preview {
    width: 100%;
    height: 120px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .guide-media-preview img,
  .guide-media-preview video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .guide-media-details {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .guide-media-details strong {
    color: #111827;
    font-size: 0.88rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .guide-media-details small {
    color: #9ca3af;
    font-size: 0.78rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .guide-media-actions {
    display: flex;
    gap: 6px;
  }

  .guide-media-actions .btn {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 6px 8px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #d1d5db;
    color: #374151;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .guide-media-actions .btn:hover {
    background: ${LG_COLOR};
    border-color: ${LG_COLOR};
    color: white;
  }

  /* Loading State */
  .guide-admin-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    min-height: calc(100vh - 200px);
  }

  .guide-admin-loading .spinner-border {
    width: 48px;
    height: 48px;
    color: ${LG_COLOR};
  }

  .guide-admin-loading p {
    color: #6b7280;
    font-size: 1rem;
    font-weight: 500;
  }

  /* Utility Classes */
  .guide-muted-copy {
    margin: 8px 0 0;
    color: #9ca3af;
    font-size: 0.88rem;
    line-height: 1.5;
  }

  .guide-empty-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 24px;
    border: 2px dashed #d1d5db;
    border-radius: 8px;
    background: #f9fafb;
    text-align: center;
  }

  .guide-empty-card h4 {
    margin: 0;
    color: #374151;
    font-size: 1rem;
    font-weight: 600;
  }

  .guide-empty-card p {
    margin: 0;
    color: #9ca3af;
    font-size: 0.94rem;
  }

  /* Responsive Design */
  @media (max-width: 1400px) {
    .guide-admin-workspace {
      grid-template-columns: 280px 1fr 320px;
    }
  }

  @media (max-width: 1100px) {
    .guide-admin-workspace {
      grid-template-columns: 1fr;
    }

    .guide-topics-card,
    .guide-editor-card,
    .guide-media-card {
      max-height: none;
    }

    .guide-admin-topic-list {
      max-height: 300px;
    }

    .guide-media-grid {
      grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    }

    .guide-authoring-group-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 768px) {
    .guide-admin-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      padding: 18px 20px;
    }

    .guide-admin-header h1 {
      font-size: 1.5rem;
    }

    .guide-admin-actions {
      width: 100%;
      justify-content: flex-end;
    }

    .guide-settings-grid {
      grid-template-columns: 1fr;
    }

    .guide-admin-tabs {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    .guide-admin-workspace {
      grid-template-columns: 1fr;
    }

    .guide-media-grid {
      grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    }
  }

  .guide-admin-header,
  .guide-settings-card,
  .guide-admin-tabs,
  .guide-topics-card,
  .guide-editor-card,
  .guide-media-card {
    background: ${WHITE_COLOR};
    border: 1px solid #dde2e8;
    border-radius: 8px;
    box-shadow: 0 8px 22px rgba(65, 70, 80, 0.08);
  }

  .guide-admin-header {
    align-items: flex-start;
    padding: 22px 24px;
  }

  .guide-admin-header > h1 {
    display: none;
  }

  .guide-admin-title-block {
    min-width: 0;
  }

  .guide-admin-eyebrow {
    color: ${LG_COLOR};
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0;
    margin-bottom: 6px;
    text-transform: uppercase;
  }

  .guide-admin-title-block h1 {
    color: ${GRAPHITE_COLOR};
    font-size: 1.65rem;
    font-weight: 600;
    line-height: 1.25;
    margin: 0;
  }

  .guide-admin-title-block p {
    color: #66707d;
    margin: 8px 0 0;
    max-width: 760px;
  }

  .guide-alert-stack {
    display: grid;
    gap: 10px;
  }

  .guide-alert-stack:empty {
    display: none;
  }

  .guide-alert-stack .alert {
    margin: 0;
  }

  .guide-admin-shell > .alert {
    margin: 0;
  }

  .guide-settings-card,
  .guide-media-card {
    padding: 18px;
  }

  .guide-settings-card h2,
  .guide-media-header h2,
  .guide-editor-card h2,
  .guide-topics-card-header h2 {
    color: ${GRAPHITE_COLOR};
    font-size: 1rem;
    font-weight: 700;
  }

  .guide-admin-tabs {
    background: #f3f5f8;
    border-bottom-color: #d9dde3;
    box-shadow: 0 5px 16px rgba(65, 70, 80, 0.06);
    padding: 10px 10px 0;
  }

  .guide-admin-tabs button {
    border: 1px solid transparent;
    border-radius: 8px 8px 0 0;
    color: ${GRAPHITE_COLOR};
    min-height: 42px;
    padding: 10px 14px;
  }

  .guide-admin-tabs button.active {
    background: ${WHITE_COLOR};
    border-color: #d9dde3 #d9dde3 ${WHITE_COLOR};
    border-bottom: 1px solid ${WHITE_COLOR};
    color: ${LG_COLOR};
    padding-bottom: 10px;
  }

  .guide-admin-workspace {
    grid-template-columns: minmax(280px, 320px) minmax(0, 1fr);
    align-items: stretch;
    gap: 0;
    overflow: hidden;
  }

  .guide-admin-workspace.topics-collapsed {
    grid-template-columns: 96px minmax(0, 1fr);
  }

  .guide-topics-card,
  .guide-editor-card {
    max-height: calc(100vh - 360px);
    min-height: 620px;
  }

  .guide-topics-card {
    border-radius: 8px 0 0 8px;
    overflow: hidden;
    transition: width 0.18s ease;
  }

  .guide-topics-card.is-collapsed {
    align-items: center;
  }

  .guide-topics-card.is-collapsed .guide-topics-card-header {
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 150px;
  }

  .guide-topics-card.is-collapsed h2 {
    font-size: 0.95rem;
    writing-mode: horizontal-tb;
    white-space: nowrap;
    text-align: center;
  }

  .guide-topics-header-actions {
    align-items: center;
    display: flex;
    gap: 8px;
  }

  .guide-topic-collapse-button {
    align-items: center;
    background: #fff;
    border: 1px solid #dde2e8;
    border-radius: 8px;
    color: ${GRAPHITE_COLOR};
    cursor: pointer;
    display: inline-flex;
    height: 34px;
    justify-content: center;
    width: 34px;
  }

  .guide-topic-collapse-button:hover {
    border-color: ${LG_COLOR};
    color: ${LG_COLOR};
  }

  .guide-editor-card {
    border-left: 0;
    border-radius: 0 8px 8px 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: 0;
  }

  .guide-editor-card-header {
    align-items: flex-start;
    border-bottom: 1px solid #d9dde3;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    padding: 16px 18px;
  }

  .guide-editor-card-header h2,
  .guide-preview-pane h3 {
    color: ${GRAPHITE_COLOR};
    font-size: 1rem;
    font-weight: 700;
    margin: 0;
  }

  .guide-editor-card-header p {
    color: #66707d;
    font-size: 0.86rem;
    margin: 4px 0 0;
  }

  .guide-help-button {
    align-items: center;
    background: ${LG_COLOR};
    border-color: ${LG_COLOR};
    color: ${WHITE_COLOR};
    display: inline-flex;
    gap: 8px;
    white-space: nowrap;
  }

  .guide-help-button:hover,
  .guide-help-button:focus {
    background: #8d012d;
    border-color: #8d012d;
    color: ${WHITE_COLOR};
  }

  .guide-editor-split {
    display: grid;
    flex: 1;
    grid-template-columns:
      minmax(260px, var(--guide-editor-width))
      8px
      minmax(320px, 1fr);
    min-height: 0;
    overflow: hidden;
  }

  .guide-topic-editor-pane,
  .guide-preview-pane {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: auto;
    padding: 18px;
  }

  .guide-topic-editor-pane {
    gap: 16px;
  }

  .guide-topic-editor-pane .form-group {
    margin: 0;
  }

  .guide-topic-editor-pane .form-group:last-of-type {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
  }

  .guide-topic-editor-pane .form-group:last-of-type .form-control {
    flex: 1;
  }

  .guide-editor-resize-handle {
    background:
      linear-gradient(90deg, transparent 0, transparent 3px, #cfd6df 3px, #cfd6df 5px, transparent 5px);
    border: 0;
    cursor: col-resize;
    min-height: 100%;
    padding: 0;
  }

  .guide-editor-resize-handle:hover {
    background:
      linear-gradient(90deg, transparent 0, transparent 2px, ${LG_COLOR} 2px, ${LG_COLOR} 6px, transparent 6px);
  }

  .guide-preview-pane {
    background: #fbfcfe;
    border-left: 1px solid #e3e7ec;
    gap: 12px;
  }

  .guide-preview-pane > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
  }

  .guide-topic-meta-footer {
    border-top: 1px solid #e3e7ec;
    padding-top: 12px;
  }

  .guide-admin-topic-list {
    max-height: none;
  }

  .guide-admin-topic-list button {
    border-radius: 8px;
  }

  .guide-admin-topic-list button.active {
    background: #fff5f8;
    border-color: ${LG_COLOR};
    box-shadow: inset 3px 0 0 ${LG_COLOR};
  }

  .guide-admin-live-preview {
    background: #f8f9fb;
    border-color: #e3e7ec;
    border-radius: 8px;
    flex: 1;
    min-height: 0;
    overflow: auto;
  }

  .guide-html-textarea {
    min-height: 420px !important;
    resize: none;
  }

  .guide-media-header {
    margin-bottom: 18px;
  }

  .guide-version-card .guide-media-header {
    align-items: center;
    margin-bottom: 0;
  }

  .guide-version-list {
    border-top: 1px solid #e3e7ec;
    display: grid;
    gap: 10px;
    margin-top: 18px;
    padding-top: 16px;
  }

  .guide-version-toggle {
    align-items: center;
    display: inline-flex;
    gap: 8px;
  }

  .guide-media-header .btn,
  .guide-admin-actions .btn.btn-secondary,
  .guide-topics-card-header .btn:hover,
  .guide-media-actions .btn:hover {
    background: ${LG_COLOR};
    border-color: ${LG_COLOR};
    color: ${WHITE_COLOR};
  }

  .guide-admin-actions .btn.btn-secondary:not(:disabled):hover,
  .guide-media-header .btn:hover {
    background: #8d012d;
    border-color: #8d012d;
    filter: none;
  }

  .guide-settings-grid .form-control:focus,
  .guide-editor-card .form-control:focus {
    border-color: ${MAIN_BLUE_COLOR};
    box-shadow: 0 0 0 0.18rem rgba(22, 81, 119, 0.16);
  }

  @media (max-width: 1100px) {
    .guide-topics-card,
    .guide-editor-card {
      max-height: none;
      min-height: 0;
    }

    .guide-admin-workspace,
    .guide-admin-workspace.topics-collapsed {
      grid-template-columns: 1fr;
    }

    .guide-topics-card,
    .guide-editor-card {
      border-radius: 8px;
      border-left: 1px solid #dde2e8;
    }

    .guide-topics-card.is-collapsed .guide-topics-card-header {
      min-height: 0;
    }

    .guide-editor-split {
      grid-template-columns: 1fr;
    }

    .guide-editor-resize-handle {
      display: none;
    }
  }

  @media (max-width: 768px) {
    padding: 16px;

    .guide-admin-header {
      padding: 18px;
    }
  }
`;
